export const API_URL = process.env.REACT_APP_API;
export const API_URL2 = process.env.REACT_APP_API_2;
export const image_url = process.env.REACT_APP_IMAGE;
export const image_url2 = process.env.REACT_APP_IMAGE_2;
